<template>
  <div id="app">
    <el-container>
      <el-header>
        <div class="logo">
          <img src="./assets/img/meyley_logo.png" alt />
        </div>
        <el-menu :default-active="defaultActive" class="el-menu-demo" mode="horizontal" @select="handleSelect"
          :router="router">
          <el-menu-item index="/">首页</el-menu-item>
          <!-- <el-menu-item index="/product">产品服务</el-menu-item> -->
          <el-menu-item index="/goin">关于我们</el-menu-item>
          <el-submenu index="2">
            <template slot="title"><i class="el-icon-s-unfold"></i></template>
            <el-menu-item index="meyley">管理登录</el-menu-item>
            <el-menu-item index="apply">申请入驻</el-menu-item>
            <!-- <el-menu-item index="yuncang">登录</el-menu-item> -->
          </el-submenu>
        </el-menu>
      </el-header>
      <el-main>
        <div v-if="showDialog" class="dialog-container">
          <div class="dialog">
            <el-form ref="form" :model="form" label-width="80px">
              <el-form-item label="手机号">
                <el-input v-model="form.mobile"></el-input>
              </el-form-item>
              <el-form-item label="验证码">
                <div style="display: flex;flex-direction: row;">
                  <el-input v-model="form.code">
                  </el-input>
                  <el-button style="margin-left: 8px;" type="primary" @click="getVcode" :disabled="waitGetVCode">{{
                    waitCount
                    }}</el-button>
                </div>

              </el-form-item>

              <p style="margin: 10px;">没有注册的手机号会自动创建账号</p>

              <el-form-item>
                <el-button type="primary" @click="login">登录</el-button>
                <el-button @click="cancle">取消</el-button>
              </el-form-item>
            </el-form>
          </div>
        </div>
        <router-view />
      </el-main>
      <div class="footer">
        <div class="slide-three flex-column-center">
          <div class="flex-row">
            <a style="color: #fff;" href="https://beian.miit.gov.cn/" target="_blank">ICP备案号:</a>
            <a style="color: #fff;" href="https://beian.miit.gov.cn/" target="_blank">浙ICP备2022021990号-1</a>
          </div>

          <div>Copyright © 2013 - 2024 meyley.com All Rights Reserved. 魅力网 版权所有</div>
        </div>

      </div>
    </el-container>
  </div>
</template>

<script>
export default {
  data() {
    return {
      router: true,
      defaultActive: "/",
      isShow: false,
      showDialog: false,
      form: {},
      waitGetVCode: false,
      waitCount: '获取验证码',
      applyStatus: 0
    };
  },
  created() {
    this.checkStatus();
  },
  methods: {
    checkStatus() {
      const applyId = sessionStorage.getItem("id");
      if (applyId) {
        // 暂时注释掉这个API请求，因为它可能不存在或路径已更改
        // this.$http
        //   .get(`/supplier/applyInfo?id=${applyId}`)
        //   .then(response => {
        //     window.console.log(response);
        //     this.applyStatus = response.data.data.status;
        //     if (this.applyStatus == 1) {
        //       this.$router.push({ name: "applyPage" });
        //     } else if (this.applyStatus == 0) {
        //       this.$router.push({ name: "logined" });
        //     } else if (this.applyStatus == 2) {
        //       this.$router.push({ name: "submited" });
        //     } else if (this.applyStatus == 3) {
        //       this.$router.push({ name: "submited" });
        //     } else if (this.applyStatus == 4) {
        //       this.$router.push({ name: "submited" });
        //     }
        //   })
        //   .catch(error => {
        //     console.error("API请求失败:", error);
        //   });
      }
    },

    handleSelect(key) {
      // window.console.log(key);
      // this.isShow = this.defaultActive != key;
      // window.console.log(this.isShow);

      if (key == "meyley") {
        window.open("https://partner.meyley.com/index.html/#/login");
      } else if (key == "apply") {
        this.showDialog = true;
      } else if (key == "yuncang") {
        window.open("https://yuncang.meyley.com/index.html/#/login");
      }
    },
    getVcode() {
      if (!this.form.mobile) {
        this.$message.error('请输入手机号！')
        return;
      }

      this.waitGetVCode = true;
      // 倒计时
      let count = 60;
      const timer = setInterval(() => {
        if (count > 0) {
          this.waitGetVCode = true;
          count--;
          this.waitCount = count + 's';
        } else {
          clearInterval(timer);
          this.waitCount = '获取验证码'
          this.waitGetVCode = false;
        }
      }, 1000);



      this.$http
        .get(`/sms/send?mobile=${this.form.mobile}`)
        .then(response => {
          window.console.log(response);
          if (response.status != 200) {
            this.$message.error(response.message);
          }
          else if (response.data.code == 200) {
            this.$message({
              message: '验证码已发送，请注意查收！',
              type: 'success'
            });



          } else {
            this.$message.error(response.data.data.msg);
          }

        })
        .catch(function () {
          this.$message.error('验证码发送失败！')
        });
    },
    login() {
      if (!this.form.mobile) {
        this.$message.error('请输入手机号！')
        return;
      }
      if (!this.form.code) {
        this.$message.error('请输入验证码！')
        return;
      }
      this.$http
        .get(`/meyley/loginBySms?mobile=${this.form.mobile}&code=${this.form.code}`)
        .then(response => {
          window.console.log(response);
          if (response.data.code != 200) {
            this.$message.error(response.message);
          } else {
            const data = response.data.data;
            this.$message({
              message: '登录成功！',
              type: 'success'
            });
            this.showDialog = false
            sessionStorage.setItem("id", data.id);
            // 根据供应商状态跳转页面
            if (data.status == 1) {
              this.$router.push({ name: "applyPage" });
            } else if (data.status == 0) {
              this.$router.push({ name: "logined" });
            } else if (data.status == 2) {
              this.$router.push({ name: "submited" });
            } else if (data.status == 3) {
              this.$router.push({ name: "submited" });
            } else if (data.status == 4) {
              this.$router.push({ name: "submited" });
            }

          }

        })
        .catch(function () {
          this.$message.error('登录失败！')
        });
    },
    cancle() {
      this.showDialog = false;
    }
  }
};
</script>

<style lang="scss">
* {
  padding: 0;
  margin: 0;
}

html,
body {
  height: 100%;
}

#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}

.el-header {
  display: flex;
  justify-content: space-between;
  align-content: center;
  width: 1240px;
  margin: 0 auto;
  //background-color: #fff;

  .logo {
    width: 280px;
    padding: 10px;

    img {
      width: 100%;
      line-height: 60px;
    }
  }
}

.el-main {
  padding: 0 !important;
}

.footer {
  .slide-three {
    margin-top: 40px;
    height: 164px;
    width: 100%;
    background-color: #5677fc;
    opacity: 0.75;

    color: #ffffff;
  }
}

// 申请对话框样式
.dialog-container {
  position: fixed;
  top: 0;
  right: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 1000;
}

.dialog {
  width: 300px;
  height: 500px;
  background-color: #fff;
  border-radius: 4px;
  padding: 20px;
  display: flex;
  flex-direction: column;
  justify-content: center;

  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
  transform: translateX(100%);
  transition: transform 0.3s ease-in-out;
}

.dialog-container .dialog {
  transform: translateX(0);
}
</style>
